import React, {Fragment, useState, useEffect} from "react"
import {ApplyLicensesModal} from './modal/ApplyMultipleLicenses'
import { deleteMember } from '../actions/member'
import { useDispatch,  } from 'react-redux'
import { Redirect } from "react-router-dom"
import UpdateMember from './modal/UpdateMember';
import ModalWrapper from './modal/ModalWrapper';
import ApplyLicense from './modal/ApplyLicense';
import {Button, Grid, Typography, Checkbox, TableContainer, TableBody, TableCell, TableHead, TableRow, Table } from "@material-ui/core"
import TablePagination from '@material-ui/core/TablePagination';
import Drawer from '@material-ui/core/Drawer';
import UpdateMembersDrawer from './updateDrawer'
import moment from 'moment'
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
import CheckForIssues, { AuditSnackbar } from './CheckForIssues';


/*******************************************************
 * @description Disply a cell with sorting label
 * @params 
 *  - text: text to display
 *  - onClick: Handle sorting
 *  - isActive: is cell sorting active
 *  - direction: sort label direction
 * @todo 
*******************************************************/
const TableCellWithSort = ({text, onClick, isActive, direction }) => {
  return (
    <TableCell > 
      <TableSortLabel
        active={isActive}
        direction={direction}
        onClick={onClick}
      >
        {text} 
      </TableSortLabel> 
    </TableCell>
  )
}

/*******************************************************
 * @description heler function to generate the props for
 * a cell is selected
 * @params 
 *  - text: cell name to check against sort label
 * @todo 
*******************************************************/
const isCellSorted = (cellName, activeSortLabel, sortOrder) => {
  return {
    isActive: activeSortLabel === cellName,
    direction: activeSortLabel === cellName ? sortOrder : 'asc'
  }
}

const MemberRow = ({member, selected, onSelect, onAuditResult}) => {
  const [editMemberOpen, setOpen] = useState(false)
  const missingAccount = member.account_number === undefined || member.account_number === null || member.account_number === ''
  const street = [member.street1, member.street2].filter(Boolean).join(', ')
  const locality = [[member.city, member.state].filter(Boolean).join(', '), member.zip].filter(Boolean).join(' ')
  const emails = (member.notification_emails || '').split(',').map(email => email.trim()).filter(Boolean)
  return(
    <TableRow hover key={member.clinic_id} selected={selected}
      className={'members-table__row' + (missingAccount ? ' members-table__row--incomplete' : '')}>
      <TableCell padding="checkbox">
        <Checkbox size="small" color="primary"
          inputProps={{ 'aria-label': 'Select ' + (member.clinic_name || member.clinic_id) }}
          onChange={onSelect}
          checked={selected}
        />
      </TableCell>
      <TableCell className="members-table__identity">
        <span className="members-table__primary members-table__id">{member.clinic_id}</span>
        {missingAccount ? <span className="members-table__missing">No account number</span> :
          <span className="members-table__secondary">Account {member.account_number}</span>}
      </TableCell>
      <TableCell className="members-table__clinic">
        <div className="members-table__clinic-heading">
          <span className="members-table__primary">{member.clinic_name || member.clinic_id}</span>
          {member.has_issues && <Tooltip title={member.issue_description || 'Clinic has scheduling issues'}>
            <span tabIndex={0} className="members-table__warning">
              <WarningIcon fontSize="small" titleAccess="Clinic has scheduling issues" />
            </span>
          </Tooltip>}
        </div>
        {street && <span className="members-table__secondary">{street}</span>}
        {locality && <span className="members-table__secondary">{locality}</span>}
        {member.audit_excluded && <span className="members-table__status members-table__status--muted">Audit excluded</span>}
      </TableCell>
      <TableCell className="members-table__email">
        {emails.length ? emails.map((email, index) => <span className="members-table__email-address" key={index}>{email}</span>) :
          <span className="members-table__secondary">Not provided</span>}
      </TableCell>
      <TableCell className="members-table__customer">
        <span className={member.customer ? 'members-table__customer-name' : 'members-table__secondary'}>
          {member.customer ? member.customer.name : 'Unassigned'}
        </span>
      </TableCell>
        <TableCell className="members-table__license">
          {member.license ? <>
            <span className="members-table__status members-table__status--active">Active license</span>
            {member.license.activation_date && <span className="members-table__secondary members-table__license-dates">
              {moment.utc(member.license.activation_date).format('MMM D, YYYY')}
              {member.license.expiration_date && <> to<br />{moment.utc(member.license.expiration_date).format('MMM D, YYYY')}</>}
            </span>}
          </> : <ModalWrapper title="Apply License" buttonText="Apply License" width={800} showOk={false}
            component={ApplyLicense} member={member} />}
        </TableCell>
        <TableCell align="right">
          <Grid container spacing={1} direction="column" alignItems="flex-end" className="member-row-actions">
            <Grid item>
              <Button size="small" variant="outlined" color="primary" startIcon={<EditIcon fontSize="small" />} onClick={() => setOpen(true)}>Edit</Button>
            </Grid>
            <Grid item>
              <CheckForIssues member={member} onResult={onAuditResult} />
            </Grid>

            <Drawer anchor="right" open={editMemberOpen} onClose={() => setOpen(false)}
              PaperProps={{ className: 'member-editor-drawer', role: 'dialog', 'aria-label': 'Edit member' }}>
              {editMemberOpen && <UpdateMember  member={member} onClose={() => setOpen(false)}/>}
            </Drawer>
          </Grid>
        </TableCell>
      </TableRow>
  )
}

const MembersTableContent = ({page, rowsPerPage, members, onSort}) => {
  const [auditResult, setAuditResult] = useState(null)
  const [selectedRows, setSelected ] = useState(new Set())
  const [redirectToSyncPage, setRedirectToSyncPage] = useState(false)

  const [activeSortLabel, setActiveSort] = useState('')
  const [sortOrder, setSortOrder] = useState('desc')

  const onSelectSort = (selectedLabel) => {
    setSortOrder(onSort(selectedLabel, sortOrder))
    setActiveSort(selectedLabel)
  }

  const onRedirectToSync = () => {
    try {
      localStorage.setItem('syncClinicIds', JSON.stringify([...selectedRows]))
    } catch (err) {
      console.error("Error saving to local state: ", err)
    }
    setRedirectToSyncPage(true)
  }

  const onClickCheckbox = (id) => {
    let rows = new Set(selectedRows)
    selectedRows.has(id) ? rows.delete(id) : rows.add(id)
    if(rows.has('all')) {
      rows.delete('all')
    }
    setSelected(rows)
  }

  const onClickAllCheckBox = () => {
    let rows = new Set(selectedRows)
    if(rows.has('all'))  {
      setSelected(new Set()) 
    } else {
      members.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( ({clinic_id}) => {
        rows.add(clinic_id)
      })
      rows.add('all')
      setSelected(rows)
    }
  }

  if(redirectToSyncPage)
    return <Redirect to="/admin/syncMembers" />

  //cache calculation
  const sliceStart = page * rowsPerPage
  const sliceEnd = sliceStart + rowsPerPage
  return(
      <Fragment>
        <TableContainer className="members-table__scroll">
          <Table size="small" className="members-table__grid" aria-label="Members">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox size="small" color="primary" inputProps={{ 'aria-label': 'Select all members on this page' }}
                    onChange={onClickAllCheckBox}
                    checked={selectedRows.has('all')}
                  />
                </TableCell>
                <TableCellWithSort 
                  text="Clinic ID"
                  onClick={() => onSelectSort("clinic_id")}
                  {...isCellSorted("clinic_id", activeSortLabel, sortOrder )}
                />
                <TableCellWithSort 
                  text="Clinic"
                  onClick={() => onSelectSort("clinic_name")}
                  {...isCellSorted("clinic_name", activeSortLabel, sortOrder )}
                />
                <TableCell>Email</TableCell>
                <TableCell>Customer</TableCell>
                <TableCellWithSort 
                  text="License"
                  onClick={() => onSelectSort("license_id")}
                  {...isCellSorted("license_id", activeSortLabel, sortOrder )}
                />
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.slice(sliceStart, sliceEnd).map(member => <MemberRow member={member} key={member.clinic_id + 'row'} selected={selectedRows.has(member.clinic_id)} onSelect={() => onClickCheckbox(member.clinic_id)} onAuditResult={setAuditResult}/>)}
            </TableBody>
          </Table>
        </TableContainer>
        {members.length === 0 && <div className="members-table__empty" role="status">No members found.</div>}
        <MembersTableFooter 
          members={members.filter( ({clinic_id}) => selectedRows.has(clinic_id) )} 
          onRedirect={onRedirectToSync} 
        />
        <AuditSnackbar result={auditResult} onClose={() => setAuditResult(null)} />
    </Fragment>
  )
}

const MembersTableFooter = ({onRedirect, members}) => {
  const dispatch = useDispatch()

  const onDeleteMembers = () => {
    for(const {_id} of members) {
      dispatch(deleteMember(_id))
    }
    //setSelected(new Set())
  }

  return(
    <Drawer anchor="bottom" open={members.length !== 0} variant="persistent" PaperProps={{ className: 'members-selection-bar' }}>
      <div className="members-selection-bar__content">
        <Typography variant="body2">{members.length} selected</Typography>
        <div className="members-selection-bar__actions">
            <ApplyLicensesModal members={members} displayBtn={true}/> 
            <UpdateMembersDrawer members={members} />
            <Button size="small" color="primary" onClick={onRedirect} startIcon={<SyncIcon fontSize="small" />}>Sync with Sycle API</Button>
            <Button size="small" onClick={onDeleteMembers} className="members-selection-bar__delete" startIcon={<DeleteOutlineIcon fontSize="small" />}>Delete</Button>
        </div>
      </div>
    </Drawer>
  )
}

const TablePaginationActions = ( { count, page, rowsPerPage, onChangePage }) => {
  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{display: 'flex'}}>
      <IconButton
        size="small"
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton size="small" onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        size="small"
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight /> 
      </IconButton>
      <IconButton
        size="small"
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </div>
  );
}


const MembersTable = ({members, onSort}) => {
  const [page, setPage ] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(50)

  const onChangePage = page => {
    setPage(page)
  }

  /*----------------------------------------------------------
   * If the member list changes (thru sorting or searching etc..)
   * reset page back to 0 to display newest results
  ----------------------------------------------------------*/
  useEffect( () => {
    setPage(0)   
  }, [members])

  const onChangeRowsPerPage = value => {
    const newLength = value === -1 ? members.length : Number(value)
    const newMaxPage = Math.floor(members.length / newLength)
    setRowsPerPage(newLength)
    if(page > newMaxPage) //set to last page
      setPage(newMaxPage)
  }

  return(
    <section className="members-table" aria-label="Member directory">
        <div className="members-table__summary">
          <span>{members.length} {members.length === 1 ? 'member' : 'members'}</span>
          <span>Page {page + 1} of {Math.max(1, Math.ceil(members.length / rowsPerPage))}</span>
        </div>
        <MembersTableContent rowsPerPage={rowsPerPage} page={page} members={members} onSort={onSort} />
        <TablePagination
            rowsPerPageOptions={[20, 30, 50, 100, {label: 'All', value: -1}]}
            component="div"
            count={members.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(e, v) => onChangePage(v)}
            onChangeRowsPerPage={e => onChangeRowsPerPage(e.target.value)} 
            ActionsComponent={TablePaginationActions}
        />
    </section>
  )
}

export default MembersTable
